import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import { ClassNameMap } from "@material-ui/styles";
import HeadColored from "@saleor/components/HeadColored";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { FC } from "react";

import ModalProcessing from "./ModalProcessing";

const useStyle = makeStyles(
  () => ({
    mainPanel: {
      background: "transparent"
    },
    headTextLogo: {
      margin: "120px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    }
  }),
  { name: "OrderProcessing" }
);
interface OrderProcessingProps {
  isCreateOrder?: boolean;
  styles?: ClassNameMap<"container" | "root" | "footer">;
}
const OrderProcessing: FC<OrderProcessingProps> = ({
  isCreateOrder,
  styles
}) => {
  const classes = useStyle();
  return (
    <>
      <HeadColored fixedTop />
      <div className={styles.container}>
        <div className={styles.root}>
          <div className={classes.mainPanel}>
            <div className={classes.headTextLogo}>
              <div className={classes.text}>
                <img src={SCGP_Color} alt={"logo_scg"} />
              </div>
              <div className={classes.logo}>
                <img src={EOrderingLogo} alt={"logo"} />
              </div>
            </div>
            <ModalProcessing isCreateOrder={isCreateOrder} />
          </div>
        </div>
        <footer className={styles.footer}>
          <MyTypography variant="body3" style={{ color: "#333333" }}>
            COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
          </MyTypography>
        </footer>
      </div>
    </>
  );
};

export default OrderProcessing;
